import React from 'react';

const ThumbsUp: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 34" {...props}>
    <path
      fill="currentColor"
      d="M36 15.551a3.749 3.749 0 00-3.75-3.75h-9.466a.374.374 0 01-.356-.492 13.028 13.028 0 00.78-6.61c-.882-3.15-2.751-4.05-4.212-3.848A3 3 0 0016.5 3.926c0 4.119-3.194 8.619-6.051 10.591a.75.75 0 00-.324.619V30.31a.75.75 0 00.607.736c.536.102 1.022.203 1.481.3 2.019.48 4.087.717 6.162.707h9.75c2.937 0 3.375-1.65 3.375-2.625 0-.518-.118-1.029-.346-1.493a3.377 3.377 0 001.5-4.5 3.373 3.373 0 001.438-4.617A3.75 3.75 0 0036 15.551zm-28.125-.375a1.5 1.5 0 00-1.5-1.5H1.5a1.5 1.5 0 00-1.5 1.5v16.5a1.5 1.5 0 001.5 1.5h4.875a1.5 1.5 0 001.5-1.5v-16.5zm-2.25 13.875a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z"
    ></path>
  </svg>
);

export default ThumbsUp;
